var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormcheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16Z",
    fill: "#ECF8F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8519 16C27.8519 22.5456 22.5456 27.8519 16 27.8519C9.4544 27.8519 4.14815 22.5456 4.14815 16C4.14815 9.4544 9.4544 4.14815 16 4.14815C22.5456 4.14815 27.8519 9.4544 27.8519 16Z",
    fill: "#DAF1E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 9.48148C12.3999 9.48148 9.48148 12.3999 9.48148 16C9.48148 19.6001 12.3999 22.5185 16 22.5185C19.6001 22.5185 22.5185 19.6001 22.5185 16C22.5185 12.3999 19.6001 9.48148 16 9.48148ZM8.2963 16C8.2963 11.7454 11.7454 8.2963 16 8.2963C20.2546 8.2963 23.7037 11.7454 23.7037 16C23.7037 20.2546 20.2546 23.7037 16 23.7037C11.7454 23.7037 8.2963 20.2546 8.2963 16ZM19.619 13.4476C19.8504 13.6791 19.8504 14.0543 19.619 14.2857L15.3524 18.5524C15.1209 18.7838 14.7457 18.7838 14.5143 18.5524L12.381 16.419C12.1496 16.1876 12.1496 15.8124 12.381 15.581C12.6124 15.3496 12.9876 15.3496 13.219 15.581L14.9333 17.2953L18.781 13.4476C19.0124 13.2162 19.3876 13.2162 19.619 13.4476Z",
    fill: "#2A6F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormcheck);
export default __webpack_public_path__ + "static/media/formcheck.9da3f54a49b5be8e77ec2f97ce7ef186.svg";
export { ForwardRef as ReactComponent };